<div class="max-w-full px-[16px] py-[24px] overflow-x-hidden bg-white flex flex-col gap-[24px]">
    <div class="space-y-[24px]">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-[16px]">
            <div>
                <h1 class="!text-2xl !font-bold text-gray-900 !mb-0">Kvalitetsläge</h1>
            </div>
            <div class="flex items-center gap-[12px]">
                <div class="relative flex text-left items-center">
                    <!-- Invisible toggle (peer) -->
                    <input type="checkbox" id="dropdown-toggle" class="peer hidden" />

                    <!-- Button -->
                    <label for="dropdown-toggle"
                        class="!mb-[4px] flex h-10 items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 w-48 cursor-pointer">
                        Alla
                        <svg class="ml-[8px] h-[16px] w-[16px] absolute right-[10px] top-[10px] opacity-50"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </label>

                    <!-- Dropdown Menu -->
                    <div
                        class="absolute right-0 top-[100%] mt-0 w-56 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none hidden peer-checked:block">
                        <div class="py-1">
                            <a href="javascript:void(0)" class="block px-[16px] py-[4px] text-sm !text-gray-900 !no-underline">Alla</a>
                            <a href="javascript:void(0)" class="block px-[16px] py-[4px] text-sm !text-gray-900 !no-underline">Åsberga
                                Eventhall</a>
                            <a href="javascript:void(0)" class="block px-[16px] py-[4px] text-sm !text-gray-900 !no-underline">Lindholmen
                                Kongress</a>
                            <a href="javascript:void(0)"
                                class="flex items-center px-[16px] py-[4px] text-sm !text-gray-900 !no-underline">
                                <svg class="w-4 h-4 mr-2 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M5 13l4 4L19 7" />
                                </svg>
                                Björkvik Arena
                            </a>
                            <a href="javascript:void(0)" class="block px-[16px] py-[4px] text-sm !text-gray-900 !no-underline">Sjöstad
                                Center</a>
                        </div>
                    </div>
                </div>
              </div>
        </div>
    </div>

    <div class="px-[20px] py-[24px] border border-gray-200 rounded-lg bg-white">
        <h2 class="text-lg !font-semibold text-gray-800 mb-[16px] flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-users text-blue-600 mr-2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            Arbetsprestationer
        </h2>

        <div
            class="px-[20px] py-[24px] bg-white rounded-lg border border-gray-200 gap-[20px] mb-[24px] !shadow-sm block">
            <h3 class="text-sm font-medium text-gray-700 mb-[16px] flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-award mr-2 text-amber-500">
                    <path
                        d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                    </path>
                    <circle cx="12" cy="8" r="6"></circle>
                </svg>
                Högpresterarna
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
                <div
                    class="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                    <div class="flex items-center mb-3" (click)="Openguardianprofile(guardianProfileModal)">
                        <div class="relative">
                            <img src="https://b3407586-9a27-4c35-ada5-013272597788.sandbox.lovable.dev/entrevard_kostym-Photoroom.jpg"
                                alt="Erik" class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" loading="lazy">
                            <div
                                class="absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center bg-amber-100 shadow-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-amber-600 fill-amber-600">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-3">
                            <div class="font-medium text-gray-900">Erik</div>
                            <div class="flex flex-wrap gap-1 mt-1">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                    Ordningsvakt
                                </span>
                            </div>
                            <div class="text-xs text-gray-500 mt-1">156 pass slutförda</div>
                        </div>
                    </div>

                    <div class="space-y-3">
                        <div>
                            <div class="flex justify-between items-center mb-1.5">
                                <span class="text-xs text-gray-600">Pålitlighet</span>
                                <span class="text-xs font-medium text-gray-800">98%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                                <div class="h-1.5 rounded-full bg-green-500" style="width: 98%;"></div>
                            </div>
                        </div>

                        <div class="flex justify-between items-center">
                            <div class="flex items-center text-green-600">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up mr-1">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                                <span class="text-xs font-medium">145</span>
                            </div>
                            <div class="text-xs text-gray-600 font-medium">95% positiva</div>
                            <div class="flex items-center text-red-600">
                                <span class="text-xs font-medium">8</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up ml-1 transform rotate-180">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                    <div class="flex items-center mb-3">
                        <div class="relative">
                            <img src="https://b3407586-9a27-4c35-ada5-013272597788.sandbox.lovable.dev/entrevard_kostym-Photoroom.jpg"
                                alt="Erik" class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" loading="lazy">
                            <div
                                class="absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center bg-amber-100 shadow-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-amber-600 fill-amber-600">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-3">
                            <div class="font-medium text-gray-900">Erik</div>
                            <div class="flex flex-wrap gap-1 mt-1">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                    Ordningsvakt
                                </span>
                            </div>
                            <div class="text-xs text-gray-500 mt-1">156 pass slutförda</div>
                        </div>
                    </div>

                    <div class="space-y-3">
                        <div>
                            <div class="flex justify-between items-center mb-1.5">
                                <span class="text-xs text-gray-600">Pålitlighet</span>
                                <span class="text-xs font-medium text-gray-800">98%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                                <div class="h-1.5 rounded-full bg-green-500" style="width: 98%;"></div>
                            </div>
                        </div>

                        <div class="flex justify-between items-center">
                            <div class="flex items-center text-green-600">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up mr-1">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                                <span class="text-xs font-medium">145</span>
                            </div>
                            <div class="text-xs text-gray-600 font-medium">95% positiva</div>
                            <div class="flex items-center text-red-600">
                                <span class="text-xs font-medium">8</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up ml-1 transform rotate-180">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="bg-gray-50 rounded-lg p-4 border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                    <div class="flex items-center mb-3">
                        <div class="relative">
                            <img src="https://b3407586-9a27-4c35-ada5-013272597788.sandbox.lovable.dev/entrevard_kostym-Photoroom.jpg"
                                alt="Erik" class="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" loading="lazy">
                            <div
                                class="absolute -bottom-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center bg-amber-100 shadow-sm">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-amber-600 fill-amber-600">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-3">
                            <div class="font-medium text-gray-900">Erik</div>
                            <div class="flex flex-wrap gap-1 mt-1">
                                <span
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                                    Ordningsvakt
                                </span>
                            </div>
                            <div class="text-xs text-gray-500 mt-1">156 pass slutförda</div>
                        </div>
                    </div>

                    <div class="space-y-3">
                        <div>
                            <div class="flex justify-between items-center mb-1.5">
                                <span class="text-xs text-gray-600">Pålitlighet</span>
                                <span class="text-xs font-medium text-gray-800">98%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                                <div class="h-1.5 rounded-full bg-green-500" style="width: 98%;"></div>
                            </div>
                        </div>

                        <div class="flex justify-between items-center">
                            <div class="flex items-center text-green-600">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up mr-1">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                                <span class="text-xs font-medium">145</span>
                            </div>
                            <div class="text-xs text-gray-600 font-medium">95% positiva</div>
                            <div class="flex items-center text-red-600">
                                <span class="text-xs font-medium">8</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-thumbs-up ml-1 transform rotate-180">
                                    <path d="M7 10v12"></path>
                                    <path
                                        d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm">
            <div class="px-[20px] py-[16px] border-b border-gray-200 bg-gray-50 ">
                <h3 class="text-sm font-medium text-gray-700 flex items-center mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-users mr-2 text-blue-600">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    Samtliga kollegors prestationer
                </h3>
            </div>

            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Namn
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Antal
                                pass</th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Pålitlighet</th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Omdömen</th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Platser</th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Åtgärder</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <tr class="hover:bg-gray-50 transition-colors">
                            <td class="px-6 py-4 whitespace-nowrap cursor-pointer">
                                <div class="flex items-center">
                                    <div class="flex-shrink-0 h-10 w-10 relative">
                                        <img src="/entrevard_kostym-Photoroom.jpg" alt="Erik"
                                            class="h-10 w-10 rounded-full object-cover border border-gray-200" loading="lazy">
                                        <div
                                            class="absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center bg-amber-100 border border-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-star text-amber-600 fill-amber-600">
                                                <polygon
                                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                                </polygon>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="ml-4">
                                        <div class="text-sm font-medium text-gray-900">Erik</div>
                                        <div class="flex flex-wrap gap-1 mt-1">
                                            <span
                                                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">Ordningsvakt</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap cursor-pointer">
                                <div class="text-sm text-gray-900 font-medium">156</div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap cursor-pointer">
                                <div class="flex items-center">
                                    <div class="text-sm text-gray-900 mr-2 font-medium">98%</div>
                                    <div class="w-24 bg-gray-200 rounded-full h-1.5 overflow-hidden">
                                        <div class="h-1.5 rounded-full bg-green-500" style="width: 98%;"></div>
                                    </div>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap cursor-pointer">
                                <div class="flex items-center">
                                    <div class="flex items-center text-green-600 mr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-thumbs-up mr-1">
                                            <path d="M7 10v12"></path>
                                            <path
                                                d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                            </path>
                                        </svg>
                                        <span class="text-xs font-medium">145</span>
                                    </div>
                                    <div class="flex items-center text-red-600">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-thumbs-up mr-1 transform rotate-180">
                                            <path d="M7 10v12"></path>
                                            <path
                                                d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                            </path>
                                        </svg>
                                        <span class="text-xs font-medium">8</span>
                                    </div>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 cursor-pointer">
                                <div class="flex flex-wrap gap-1">
                                    <span
                                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">Stockholms
                                        Centralstation</span>
                                    <span
                                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">Arlanda
                                        Terminal 5</span>
                                    <span
                                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">+1
                                        till</span>
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap">
                                <div class="flex items-center gap-2">
                                    <button
                                        class="p-1.5 rounded-full transition-all duration-300 bg-gray-100 hover:bg-amber-50 group relative"
                                        title="Markera som enastående vakt (5 stjärnor)" aria-pressed="false"
                                        type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-star transition-all duration-300 text-gray-400 group-hover:text-amber-500">
                                            <polygon
                                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                            </polygon>
                                        </svg>
                                        <span
                                            class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">Enastående
                                            vakt (5 stjärnor)</span>
                                    </button>
                                    <button class="p-1.5 rounded-full bg-gray-100 hover:bg-blue-50 group relative"
                                        title="Lämna specifik feedback" aria-label="Leave Specific Feedback">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-thumbs-up text-gray-400 group-hover:text-blue-600">
                                            <path d="M7 10v12"></path>
                                            <path
                                                d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z">
                                            </path>
                                        </svg>
                                        <span
                                            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">Lämna
                                            specifik feedback</span>
                                    </button>
                                    <button class="p-1.5 rounded-full bg-gray-100 hover:bg-red-50 group relative"
                                        title="" aria-label="Remove from All Passes and Block">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-circle-x text-gray-400 group-hover:text-red-600">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="m15 9-6 6"></path>
                                            <path d="m9 9 6 6"></path>
                                        </svg>
                                        <span
                                            class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">Ta
                                            bort från alla pass och blockera</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
    <div class="px-[20px] py-[24px] border border-gray-200 rounded-lg bg-white">
        <h2 class="text-lg font-semibold text-gray-800 mb-[16px] flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-message-square text-green-600 mr-2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            Anonyma omdömen från kollegor
        </h2>
        <div class="mb-[16px] p-[16px] bg-green-50 border border-green-200 rounded-lg">
            <div class="flex items-center mb-[8px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-shield text-green-600 mr-[8px]">
                    <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                    </path>
                </svg><span class="text-sm font-medium text-green-800">Konfidentiell feedback</span>
            </div>
            <p class="text-sm text-green-700">
                Dessa omdömen är insamlade anonymt från våra arbetstagare. De ger en ärlig bild av hur du upplevs som
                kund och kan bidra till att stärka samarbetet med säkerhetspersonalen. Samtidigt bör de tolkas med viss
                reservation.
            </p>
        </div>
        <div class="bg-gray-50 rounded-lg p-[16px] mb-[24px]">
            <div class="grid grid-cols-1 md:grid-cols-5 gap-[16px]">
                <div class="text-center">
                    <div class="text-3xl font-bold text-gray-900">4.2</div>
                    <div class="flex justify-center mb-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-yellow-400 fill-current">
                            <polygon
                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                            </polygon>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-yellow-400 fill-current">
                            <polygon
                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                            </polygon>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-yellow-400 fill-current">
                            <polygon
                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                            </polygon>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-yellow-400 fill-current">
                            <polygon
                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                            </polygon>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-gray-300">
                            <polygon
                                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                            </polygon>
                        </svg>
                    </div>
                    <div class="text-sm text-gray-600">Övergripande betyg</div>
                </div>


                <div class="text-center">
                    <div class="text-2xl font-bold text-blue-600">4.2</div>
                    <div class="text-sm text-gray-600">Kommunikation</div>
                </div>


                <div class="text-center">
                    <div class="text-2xl font-bold text-purple-600">4.3</div>
                    <div class="text-sm text-gray-600">Förberedelse</div>
                </div>


                <div class="text-center">
                    <div class="text-2xl font-bold text-green-600">4.5</div>
                    <div class="text-sm text-gray-600">Respekt</div>
                </div>


                <div class="text-center">
                    <div class="text-2xl font-bold text-orange-600">4.2</div>
                    <div class="text-sm text-gray-600">Tydlighet</div>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-[16px]">
            <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                <div class="flex items-start justify-between mb-3">
                    <div class="flex items-center">
                        <div class="flex mr-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                        </div>
                        <span class="text-sm text-gray-600">2024-01-15</span>
                    </div>
                    <div class="text-sm text-gray-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin mr-1">
                            <path
                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        Stockholms Centralstation
                    </div>
                </div>

                <p class="text-gray-700 text-sm mb-3 leading-relaxed">
                    Mycket professionell och tydlig kommunikation från kunden. Tydliga instruktioner och bra
                    förberedelser
                    inför
                    passet. Kunden var lyhörd för våra säkerhetsförslag.
                </p>

                <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                    <div class="flex items-center justify-between p-2 bg-blue-50 rounded">
                        <span class="text-blue-700">Kommunikation</span>
                        <span class="font-medium text-blue-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-purple-50 rounded">
                        <span class="text-purple-700">Förberedelse</span>
                        <span class="font-medium text-purple-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-green-50 rounded">
                        <span class="text-green-700">Respekt</span>
                        <span class="font-medium text-green-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-orange-50 rounded">
                        <span class="text-orange-700">Tydlighet</span>
                        <span class="font-medium text-orange-800">5/5</span>
                    </div>
                </div>
            </div>
            <div class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                <div class="flex items-start justify-between mb-3">
                    <div class="flex items-center">
                        <div class="flex mr-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                <polygon
                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                </polygon>
                            </svg>
                        </div>
                        <span class="text-sm text-gray-600">2024-01-15</span>
                    </div>
                    <div class="text-sm text-gray-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin mr-1">
                            <path
                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        Stockholms Centralstation
                    </div>
                </div>

                <p class="text-gray-700 text-sm mb-3 leading-relaxed">
                    Mycket professionell och tydlig kommunikation från kunden. Tydliga instruktioner och bra
                    förberedelser
                    inför
                    passet. Kunden var lyhörd för våra säkerhetsförslag.
                </p>

                <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                    <div class="flex items-center justify-between p-2 bg-blue-50 rounded">
                        <span class="text-blue-700">Kommunikation</span>
                        <span class="font-medium text-blue-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-purple-50 rounded">
                        <span class="text-purple-700">Förberedelse</span>
                        <span class="font-medium text-purple-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-green-50 rounded">
                        <span class="text-green-700">Respekt</span>
                        <span class="font-medium text-green-800">5/5</span>
                    </div>
                    <div class="flex items-center justify-between p-2 bg-orange-50 rounded">
                        <span class="text-orange-700">Tydlighet</span>
                        <span class="font-medium text-orange-800">5/5</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="px-[20px] py-[24px] border border-gray-200 rounded-lg bg-white opacity-60">
        <div class="relative">
            <div class="absolute inset-0 bg-gray-100 rounded-lg opacity-50"></div>
            <div class="relative">
                <h2 class="!text-lg !font-medium text-gray-800 !mb-[8px] flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-shield text-green-600 mr-2">
                        <path
                            d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                        </path>
                    </svg>
                    Feedback från besökare<span
                        class="ml-2 px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">Ej aktiverad</span>
                </h2>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-[24px] mb-[24px]">
                    <!-- Trygghet -->
                    <div class="bg-green-50 rounded-lg p-4 border border-green-200">
                        <div class="text-center">
                            <div class="text-2xl font-bold text-green-600 mb-[4px]">4.6</div>
                            <div class="text-green-800 text-sm">Trygghet</div>
                            <div class="flex justify-center space-x-1 mt-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-star text-yellow-400 fill-current">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- Säkerhet -->
                    <div class="bg-blue-50 rounded-lg p-4 border border-blue-200">
                        <div class="text-center">
                            <div class="text-2xl font-bold text-blue-600 mb-[4px]">4.8</div>
                            <div class="text-blue-800 text-sm">Säkerhet</div>
                            <div class="flex justify-center space-x-1 mt-2">
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- Service -->
                    <div class="bg-purple-50 rounded-lg p-4 border border-purple-200">
                        <div class="text-center">
                            <div class="text-2xl font-bold text-purple-600 mb-[4px]">4.4</div>
                            <div class="text-purple-800 text-sm">Service</div>
                            <div class="flex justify-center space-x-1 mt-2">
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-yellow-400 fill-current"
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                                <svg class="lucide lucide-star text-gray-300" xmlns="http://www.w3.org/2000/svg"
                                    width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polygon
                                        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                    </polygon>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-50 rounded-lg p-[16px] border border-gray-200">
                    <h3 class="font-semibold text-gray-800 mb-3 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-message-square mr-2">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        </svg>
                        Rapporter per plats
                    </h3>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[16px]">
                        <!-- Åsberga Eventhall -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="text-sm font-medium text-gray-800">Åsberga Eventhall</div>
                            <div class="flex items-center justify-between mt-1">
                                <span class="text-lg font-bold text-red-600">3</span>
                                <span class="text-xs text-gray-500">Störning</span>
                            </div>
                        </div>

                        <!-- Lindholmen Kongress -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="text-sm font-medium text-gray-800">Lindholmen Kongress</div>
                            <div class="flex items-center justify-between mt-1">
                                <span class="text-lg font-bold text-red-600">1</span>
                                <span class="text-xs text-gray-500">Säkerhet</span>
                            </div>
                        </div>

                        <!-- Björkvik Arena -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="text-sm font-medium text-gray-800">Björkvik Arena</div>
                            <div class="flex items-center justify-between mt-1">
                                <span class="text-lg font-bold text-red-600">5</span>
                                <span class="text-xs text-gray-500">Publik</span>
                            </div>
                        </div>

                        <!-- Sjöstad Center -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="text-sm font-medium text-gray-800">Sjöstad Center</div>
                            <div class="flex items-center justify-between mt-1">
                                <span class="text-lg font-bold text-red-600">2</span>
                                <span class="text-xs text-gray-500">Allmän</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-50 rounded-lg p-[16px] border border-gray-200 mt-[16px]">
                    <h3 class="font-semibold text-gray-800 !mb-[12px] flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-users mr-2">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        Feedback på individuella vakter
                    </h3>

                    <div class="space-y-3">
                        <!-- Erik -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="flex items-center justify-between mb-[8px]">
                                <div class="flex items-center space-x-2">
                                    <span class="font-medium text-gray-800">Erik</span>
                                    <div class="flex space-x-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 24 24" class="lucide lucide-star text-yellow-400 fill-current">
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 
                               18.18 21.02 12 17.77 5.82 21.02 
                               7 14.14 2 9.27 8.91 8.26 12 2" />
                                        </svg>
                                        <!-- upprepa stjärnor… -->
                                    </div>
                                    <span class="text-sm text-gray-600">4.9</span>
                                </div>
                                <span class="text-xs text-gray-500">Åsberga Eventhall</span>
                            </div>
                            <p class="text-sm text-gray-700 italic mb-0">"Mycket professionell och hjälpsam"</p>
                        </div>

                        <!-- Johan -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="flex items-center justify-between mb-[8px]">
                                <div class="flex items-center space-x-2">
                                    <span class="font-medium text-gray-800">Johan</span>
                                    <div class="flex space-x-1">
                                        <!-- stjärnor här -->
                                    </div>
                                    <span class="text-sm text-gray-600">4.7</span>
                                </div>
                                <span class="text-xs text-gray-500">Björkvik Arena</span>
                            </div>
                            <p class="text-sm text-gray-700 italic mb-0">"Snabb respons och vänlig service"</p>
                        </div>

                        <!-- Marcus -->
                        <div class="bg-white rounded-lg p-[12px] border border-gray-200">
                            <div class="flex items-center justify-between mb-[8px]">
                                <div class="flex items-center space-x-2">
                                    <span class="font-medium text-gray-800">Marcus</span>
                                    <div class="flex space-x-1">
                                        <!-- stjärnor här -->
                                    </div>
                                    <span class="text-sm text-gray-600">4.5</span>
                                </div>
                                <span class="text-xs text-gray-500">Sjöstad Center</span>
                            </div>
                            <p class="text-sm text-gray-700 italic mb-0">"Kunnig och trygg närvaro"</p>
                        </div>
                    </div>
                </div>

                <div class="mt-[16px] p-[12px] bg-yellow-50 border border-yellow-200 rounded-lg">
                    <p class="text-sm text-yellow-800 !mb-0">
                        <strong>Obs:</strong>
                        Säkerhetstjänst-funktionen är för närvarande inte aktiverad. Kontakta Safetly för att aktivera
                        denna funktion och börja samla in feedback från era besökare.
                    </p>
                </div>

            </div>
        </div>
    </div>



</div>

<ng-template #guardianProfileModal>
    <div class="grid w-full max-w-lg rounded-lg bg-white sm:max-w-4xl max-h-[85vh] overflow-y-auto p-[24px]">
        <div class="flex flex-col gap-[4px] text-center sm:!text-left">
            <h2 class="!text-lg !font-semibold leading-none tracking-tight !mb-0">Väktarprofil</h2>
            <p class="!text-sm text-muted-foreground">Detaljerad information om väktarens prestationer</p>
        </div>
        <div class="flex flex-col gap-[24px]">
            <div class="flex items-center space-x-4">
                <div class="relative">
                    <img src="/entrevard_kostym-Photoroom.jpg" alt="Erik"
                        class="w-20 h-20 rounded-full object-cover border-4 border-white shadow-lg" loading="lazy">
                    <div
                        class="absolute -bottom-2 -right-2 w-8 h-8 rounded-full flex items-center justify-center bg-amber-100 border-2 border-white shadow-lg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star text-amber-600 fill-amber-600">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 
                         5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                    </div>
                </div>
                <div class="flex-1">
                    <h2 class="!text-2xl !font-bold !text-gray-900 !mb-0">Erik</h2>
                    <p class="!text-gray-600 !mb-0">+46 70 123 4567</p>
                    <div class="flex items-center !mt-[8px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-star w-5 h-5 text-yellow-400 fill-current mr-1">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 
                         5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                        <span class="!text-lg !font-semibold !text-gray-900">4.8</span>
                        <span class="!text-gray-500 ml-[8px]">(153 omdömen)</span>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-2 md:grid-cols-4 gap-[16px]">
                <div class="bg-blue-50 p-[16px] rounded-lg text-center">
                    <div class="text-2xl font-bold text-blue-600">156</div>
                    <div class="text-sm text-blue-800">Pass slutförda</div>
                </div>
                <div class="bg-green-50 p-[16px] rounded-lg text-center">
                    <div class="text-2xl font-bold text-green-600">98%</div>
                    <div class="text-sm text-green-800">Pålitlighet</div>
                </div>
                <div class="bg-purple-50 p-[16px] rounded-lg text-center">
                    <div class="text-2xl font-bold text-purple-600">12</div>
                    <div class="text-sm text-purple-800">Incidenter hanterade</div>
                </div>
                <div class="bg-orange-50 p-[16px] rounded-lg text-center">
                    <div class="text-2xl font-bold text-orange-600">3.2 min</div>
                    <div class="text-sm text-orange-800">Snitt responstid</div>
                </div>
            </div>

            <div class="grid md:grid-cols-2 gap-[24px]">
                <!-- Personlig information -->
                <div class="bg-gray-50 p-[16px] rounded-lg">
                    <h3 class="!text-lg !font-semibold !text-gray-900 mb-[12px]">
                        Personlig information
                    </h3>
                    <div class="space-y-2">
                        <div class="flex justify-between">
                            <span class="!text-gray-600">Anställd sedan:</span>
                            <span class="!font-medium">15 Mar 2022</span>
                        </div>
                        <div class="flex justify-between">
                            <span class="!text-gray-600">Badge-nivå:</span>
                            <span class="!font-medium capitalize">gold</span>
                        </div>
                    </div>
                </div>

                <!-- Prestanda -->
                <div class="bg-gray-50 p-[16px] rounded-lg">
                    <h3 class="!text-lg !font-semibold !text-gray-900 mb-3">
                        Prestanda
                    </h3>
                    <div class="space-y-3">
                        <div>
                            <div class="flex justify-between mb-[4px]">
                                <span class="text-gray-600">Positiva omdömen</span>
                                <span class="font-medium">95%</span>
                            </div>
                            <div class="w-full bg-gray-200 rounded-full h-2">
                                <div class="bg-green-500 h-2 rounded-full" style="width: 95%;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid md:grid-cols-2 gap-[24px]">
                <!-- Kompetenser -->
                <div>
                    <h3 class="!text-lg !font-semibold !text-gray-900 mb-[12px]">Kompetenser</h3>
                    <div class="flex flex-wrap gap-2">
                        <span class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Ordningsvakt</span>
                        <span class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Konflikthantering</span>
                        <span class="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Första hjälpen</span>
                    </div>
                </div>

                <!-- Certifieringar -->
                <div>
                    <h3 class="!text-lg !font-semibold !text-gray-900 mb-[12px]">Certifieringar</h3>
                    <div class="flex flex-wrap gap-[8px]">
                        <span class="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Väktarutbildning</span>
                        <span class="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Brandskydd</span>
                        <span class="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">HLR</span>
                    </div>
                </div>
            </div>

            <div>
                <h3 class="!text-lg !font-semibold !text-gray-900 mb-[12px]">Arbetsplatser</h3>
                <div class="flex flex-wrap gap-2">
                    <span class="px-[12px] py-[4px] bg-gray-100 !text-gray-800 rounded-lg !text-sm flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin mr-1">
                            <path
                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        Stockholms Centralstation
                    </span>

                    <span class="px-[12px] py-[4px] bg-gray-100 !text-gray-800 rounded-lg !text-sm flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin mr-1">
                            <path
                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        Arlanda Terminal 5
                    </span>

                     <span class="px-[12px] py-[4px] bg-gray-100 !text-gray-800 rounded-lg !text-sm flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-map-pin mr-1">
                            <path
                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                            </path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        Gallerian
                    </span>
                </div>
            </div>

            <div>
                <h3 class="!text-lg !font-semibold !text-gray-900 !mb-[12px]">Senaste pass</h3>
                <div class="space-y-2">
                    <div class="flex items-center justify-between p-[12px] bg-gray-50 rounded-lg">
                        <div class="flex items-center space-x-3">
                            <div class="text-sm font-medium text-gray-900">2024-01-10</div>
                            <div class="text-sm text-gray-600">Arlanda Terminal 5</div>
                        </div>
                        <div class="flex items-center space-x-3">
                            <span class="text-sm text-gray-600">8h</span>
                        </div>
                    </div>

                    <div class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                        <div class="flex items-center space-x-3">
                            <div class="text-sm font-medium text-gray-900">2024-01-08</div>
                            <div class="text-sm text-gray-600">Stockholms Centralstation</div>
                        </div>
                        <div class="flex items-center space-x-3">
                            <span class="text-sm text-gray-600">12h</span>
                            <span class="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">1 incident</span>
                        </div>
                    </div>

                    <div class="flex items-center justify-between p-[12px] bg-gray-50 rounded-lg">
                        <div class="flex items-center space-x-3">
                            <div class="!text-sm !font-medium !text-gray-900">2024-01-05</div>
                            <div class="!text-sm !text-gray-600">Gallerian</div>
                        </div>
                        <div class="flex items-center space-x-3">
                            <span class="text-sm !text-gray-600">8h</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <button type="button"
            class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-x h-4 w-4">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
            </svg>
            <span class="sr-only">Stäng</span>
        </button>

    </div>
</ng-template>